module.exports = __webpack_public_path__ + "static/media/anatomia.2d696996.png";